<template>
    <div class="row h-100 justify-content-center align-items-center bg-warning text-light">
        <div class="col-sm-8 col-11" v-if="project">
            <h1>Proyecto</h1>
            <label for="project_nombre">Herramientas</label>
            <div class="w-100"></div>
            <button class="btn btn-success btn-sm float-right mb-2" @click="add()">
                <i class="fa fa-plus">Agregar</i>
            </button>
            <table class="table table-bordered table-sm">
                <thead>
                    <tr>
                        <th>Nombre</th>
                        <th>Descripción</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!project.herramientas.length">
                        <td colspan="2" class="text-center">Sin datos para mostrar.</td>
                    </tr>
                    <tr v-for="(item, index) of project.herramientas" :key="index">
                        <td>
                            <input type="text" class="form-control" v-model="item.nombre" />
                        </td>
                        <td>
                            <input type="text" class="form-control" v-model="item.descripcion" />
                        </td>
                        <td>
                            <button class="btn btn-light btn-sm text-danger" @click="remove(index)">x</button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <button class="btn w-100 btn-light btn-lg my-4" :disabled="disabled" @click="set">Siguiente</button>
        </div>
    </div>
</template>

<script>
import router from "../router";
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {
            project: null,
            ...mapGetters(["getProject"]),
        };
    },
    mounted() {
        this.project = this.getProject();
    },
    computed: {
        disabled: function () {
            return this.project.herramientas.length == 0;
        },
    },
    methods: {
        set() {
            this.setProject(this.project);
            router.push("Project7");
        },
        add() {
            this.project.herramientas.push({
                nombre: null,
                descripcion: null,
            });
        },
        remove(index) {
            this.project.herramientas.splice(index, 1);
        },
        ...mapActions(["setProject"]),
    },
};
</script>
